export default __webpack_public_path__ + "static/media/Idle (5).37dadf3b.png";